module.exports = __webpack_public_path__ + "img/google-blue.1a464649.svg";